<template>
  <Modal name="editReport" v-bind="$attrs" >
    <template v-slot:header>
        <h1 v-if="!creating">{{ $t('edit_report') }}</h1>
        <h1 v-else>{{ $t('create_report') }}</h1>
    </template>
    <template v-slot:body>
      <TabOutline class="padding-top-bottom border-b" />
      <TabFilters class="padding-top-bottom"
          :filterOptions="filterOptions"
          :date_from="dateFrom"
          :date_to="dateTo"
          :backward_interval="backwardInterval"
          :cover_type="coverType"
          @update="updateFilters($event)"
      />
    </template>
    <template v-slot:footer>
      <button :disabled="!!isLoading" :class="{'cursor-wait opacity-30' : !!isLoading}" class="transition btn-report sparkYellow my-5 uppercase text-bold mx-2" @click="goto('report-result')">{{ $t('run') }}</button>
    </template>
</Modal>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Modal from '../modules/modals/components/Modal'
import TabOutline from "@/components/select-report-tabs/TabOutline.vue";
import TabFilters from "@/components/select-report-tabs/TabFilters.vue";
import ModalSomethingWentWrong from "@/components/ModalSomethingWentWrong.vue";
import ModalService from "@/modules/modals/services/modal.service";

export default {
    name: 'modalEditReport',
    components: {
      TabFilters,
      TabOutline,
        Modal,
    },
    props: {
      creating: {
        type: Boolean,
        required: false,
        default: false,
      }
    },
    data(){
      return {
        isLoading: false
      }
    },
    computed: {
        ...mapGetters([
            'newReport',
            'allColumns',
            'result',
            'chartName',
        ]),
        filtersList() {
            return this.newReport.filters ? this.newReport.filters : []
        },
        filterOptions (){
            return this.allColumns.filter(column => {
                return this.newReport.service_name == column.service
            }).map(column => {
                return {name: column.name, type: column.type, label: this.$t(column.name, 1), value: null}
            })
        },
        dateFrom(){
            return this.newReport.date_from
        },
        dateTo(){
            return this.newReport.date_to
        },
        backwardInterval(){
            return this.newReport.backward_interval
        },
        coverType(){
            return this.newReport.cover_type
        },
    },
    created() {
        if (window.onbeforeunload === null) window.onbeforeunload = (event) => event.preventDefault();
    },
    methods: {
        ...mapMutations({
            setNewReportItem: 'setNewReportItem',
            setReportChoosingCollapsed: 'setReportChoosingCollapsed',
            setLastRunChartType: 'setLastRunChartType',
            setLastRunStackBy: 'setLastRunStackBy',
            setLastRunGroupBy: 'setLastRunGroupBy',
        }),
        ...mapActions({
            generateReport: 'generateReport',
            saveReport: 'saveReport',
        }),
        updateFilters(event) {
            this.setNewReportItem(event)
            this.$forceUpdate();
        },
        goto(el){
            this.isLoading = true
            const payload = {
                backward_interval: this.newReport.backward_interval,
                columns: this.newReport.view_columns_stringify,
                filters: this.newReport.filters_stringify,
                group_by: this.newReport.group_by_stringify,
                stack_by: this.newReport.stack_by_stringify,
                order_by: this.newReport.order_by_stringify,
                date_from: this.newReport.date_from,
                date_to: this.newReport.date_to,
                cover_type: this.newReport.cover_type,
                chart_id: this.newReport.chart_id,
                map: this.newReport.map ? this.newReport.map : false,
                service: this.newReport.service_name,
                aggregate: this.newReport.aggregate ? this.newReport.aggregate_stringify : null,
                additionalGroupBy: this.newReport.additionalGroupBy ? this.newReport.additionalGroupBy_stringify : null
            }
            this.generateReport(payload).then(()=> {
                document.getElementById(el).scrollIntoView({behavior: 'smooth', block: 'start', inline: 'center'})
                this.setLastRunChartType(this.chartName)
                this.setLastRunStackBy(this.newReport.stack_by)
                this.setLastRunGroupBy(this.newReport.group_by)
            }).catch(()=>{
              ModalService.open(ModalSomethingWentWrong)
            }).finally(()=> {
              this.$attrs.close()
              this.isLoading = false
              if (this.result && this.result.total !== 0) this.setReportChoosingCollapsed(true)
            })
        }
    }
}
</script>

<style lang="sass" scoped>
h1
    font-size: 25px!important
label
    font-weight: 700
    font-size: 17px
input, select, textarea
    border: 1px solid #F0F1F3!important
    border-radius: 7px
    width: 100%
input[type='checkbox']
    min-width: 25px
    width: inherit
    height: 25px
.padding-top-bottom
    padding: 1rem 0 1rem 0
</style>
